/**
 * Shared id factory for form-kit components: each component family keeps its own counter so generated ids are
 * predictable in tests (`cads-input-1`, `cads-input-2`, …) and don't collide across types.
 *
 * Internal — not part of the public form-kit API.
 */
const _counters = new Map<string, number>();

export function nextCadsFormKitId(prefix: string): string {
  const next = (_counters.get(prefix) ?? 0) + 1;
  _counters.set(prefix, next);
  return `${prefix}-${next}`;
}
